import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import cx from 'classnames';
import EnabledMicIcon from '../../../images/icons/enabledMic.svg';
import MicSlash from '../../../images/icons/iconMicOFF.svg';
import LeftTriangle from '../../../images/icons/MicrophonePointerLeft.svg';
import RightTriangle from '../../../images/icons/MicrophonePointerRight.svg';

class ReactiveListeningStatus extends React.Component {
  render() {
    const { isListening, forceActiveState, volumeLevel, large } = this.props;

    const borderPercentage = (volumeLevel / 10) * 100;

    const iconClasses = cx({
      'listeningStatusIcon': true,
      'activeIcon': isListening || forceActiveState,
      'inactiveIcon': !isListening && !forceActiveState,
    });

    const outerCx = cx({
      reactiveListeningStatusContainer: true,
      inactive: !isListening && !forceActiveState,
      large,
    });
    const middleCx = cx({
      listeningStatusMiddle: true,
      inactive: !isListening && !forceActiveState,
    })
    const innerCx = cx({
      listeningStatus: true,
      inactive: !isListening && !forceActiveState,
    });

    return (
      <div className={outerCx} style={{ '--border-percentage': `${borderPercentage}%` }}>
        <div className={middleCx}>
          <div className={innerCx}>
            {isListening || forceActiveState ? (
              <>
                <img src={LeftTriangle} className="triangle left" />
                <img src={EnabledMicIcon} className={iconClasses} />
                <img src={RightTriangle} className="triangle right" />
              </>
            ) : (
              <img src={MicSlash} className={iconClasses} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

ReactiveListeningStatus.propTypes = {
  isListening: PropTypes.bool,
  volumeLevel: PropTypes.number,
  large: PropTypes.bool,
  forceActiveState: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    isListening: get(state, 'speech.listener.isListening', null),
  }
};

export default connect(mapStateToProps)(ReactiveListeningStatus);
